import { SquareRoundedBadgeIcon } from './SquareRoundedBadgeIcon';

/**
 * author: Jeff Anders
 * id D8486DF6-E4E4-4EAF-B362-8A9FD1CF27C3
 * name square-rounded-badge
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-rounded-badge.svg
 * tags
 * - Shape 
 * - Notification 
 */
export const PushNotificationIcon = SquareRoundedBadgeIcon;
export default PushNotificationIcon